import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {ReportService} from '../../../../services';

@Component({
  selector: 'app-interim-revenue-warning-popup',
  templateUrl: './interim-revenue-warning-popup.component.html',
  styleUrls: ['./interim-revenue-warning-popup.component.scss']
})
export class InterimRevenueWarningPopupComponent {

  year: number;
  percent: number;
  fieldName: string = '';
  subject: Subject<boolean>;
  skipInterimWarning: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private reportService: ReportService
  ) {}

  onClose(): void {
    if (this.skipInterimWarning) {
      localStorage.setItem('skipInterimWarning_' + this.reportService.report.getValue().ID, 'true');
    }
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  get percentString(): number {
    return Number(Math.abs(this.percent).toFixed(1));
  }

}
